<template>
  <div class="modify__customer">
    <div class="customer__block" :class="customerDetail.id ? 'is-active' : ''">
      <h3 class="customer-header">顧客情報</h3>
      <div class="customer-detail">
        <CustomerInfo :customer="customerDetail" :isLoading="isCustomerDetailBusy" />
      </div>
    </div>
    <div class="hand__memo">
      <div class="memo-image">
        <img v-if="freehandMemo" :src="freehandMemo" alt="手書きメモ" height="100%" />
      </div>
    </div>
    <!-- /modify__customer -->
  </div>
</template>

<script>
import { formatDate } from '@/utils/date'
import CustomerInfo from '@/components/molecules/CustomerInfo'

export default {
  name: 'Customer',
  components: {
    CustomerInfo,
  },
  props: {
    customerDetail: {
      type: Object,
      default: () => {},
    },
    freehandMemo: {
      type: String,
    },
    isCustomerDetailBusy: {
      type: Boolean,
    },
  },
  computed: {},
  methods: {
    formatDate,
  },
}
</script>

<style lang="postcss" scoped>
.customer__block {
  background: url(/assets/img/icons/customer_default.png) no-repeat center center var(--white);
  background-size: 64px 64px;
  border-radius: 4px;
  box-sizing: border-box;
  max-height: 448px;
  min-height: 240px;
  width: 360px;

  &.is-active {
    background: var(--white);
  }
}

.customer-header {
  background-color: var(--dark-gray);
  border-radius: 4px 4px 0 0;
  color: var(--white);
  font-size: 15px;
  height: 32px;
  line-height: 2.13;
  text-align: center;
}

.customer-detail {
  border-bottom: 1px solid var(--border-color);
  border-left: 1px solid var(--border-color);
  border-radius: 0 0 4px 4px;
  border-right: 1px solid var(--border-color);
  box-sizing: border-box;
  height: calc(100vh - 80px - 200px - 72px);
  max-height: 416px;
  min-height: 208px;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 12px 16px 16px;
}

.hand__memo {
  background-color: var(--white);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-shadow: 0 1px var(--very-light-gray);
  box-sizing: border-box;
  height: 120px;
  margin-top: 16px;
  position: relative;
  width: 360px;
}

.memo-image {
  background: url(/assets/img/icons/hand_memo.png) no-repeat center center;
  background-size: 96px 74px;
  border: 1px solid var(--border-color);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 110px;
  margin: 4px;
  text-align: center;

  img {
    background-color: var(--white);
    display: block;
    margin: 0 auto;
  }
}
</style>
